@if (formGroup) {
  <div [formGroup]="formGroup">
    <label class="bm-fieldset-label">Firma</label>
    <input class="bm-input w-full" type="text" [formControlName]="_prefix + 'address_company'" />
  </div>
  <div class="flex flex-row gap-2" [formGroup]="formGroup">
    <div class="flex-1">
      <label class="bm-fieldset-label">Vorname</label>
      <input class="bm-input w-full" type="text" [formControlName]="_prefix + 'address_firstname'" />
    </div>
    <div class="flex-1">
      <label class="bm-fieldset-label">Nachname</label>
      <input class="bm-input w-full" type="text" [formControlName]="_prefix + 'address_lastname'" />
    </div>
  </div>
  <div class="flex flex-row gap-2" [formGroup]="formGroup">
    <div class="flex-2/3">
      <label class="bm-fieldset-label">Straße</label>
      <input class="bm-input w-full" type="text" [formControlName]="_prefix + 'address_street'" />
    </div>
    <div class="flex-1/3">
      <label class="bm-fieldset-label">Nr.</label>
      <input class="bm-input w-full" type="text" [formControlName]="_prefix + 'address_street_no'" />
    </div>
  </div>
  <div class="flex flex-row gap-2" [formGroup]="formGroup">
    <div class="flex-1/3">
      <label class="bm-fieldset-label">PLZ</label>
      <input class="bm-input w-full" type="text" [formControlName]="_prefix + 'address_zip'" />
    </div>
    <div class="flex-2/3">
      <label class="bm-fieldset-label">Ort</label>
      <input class="bm-input w-full" type="text" [formControlName]="_prefix + 'address_city'" />
    </div>
  </div>
  <div class="flex flex-row gap-2" [formGroup]="formGroup">
    <div class="flex-1">
      <label class="bm-fieldset-label">Land</label>
      <ng-select
        class="w-full"
        [items]="countries"
        [formControlName]="_prefix + 'address_country'"
        placeholder="Land"
        bindLabel="name"
        bindValue="id"
        [clearable]="false"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ item.name }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
          @if (item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
            {{ item.name }}
          }
        </ng-template>
      </ng-select>
    </div>
    <div class="flex-1">
      <label class="bm-fieldset-label">Staat</label>
      <input class="bm-input w-full" type="text" [formControlName]="_prefix + 'address_state'" />
    </div>
  </div>
}
